export const massEditContainerSelector = '.mass-edit-orders';
export const stickyBlockSelector = '.mass-edit-sticky-block';
export const fixedStickyBlockSelector = '.fixed-mass-edit-sticky-block';
export const stickyBlockPlaceholderSelector = '.mass-edit-sticky-block-placeholder';
export const stickyBlockHeaderSelector = '.mass-edit-sticky-block-header';
export const fixedStickyBlockHeaderSelector = '.fixed-mass-edit-sticky-block-header';
export const stickyBlockHeaderPlaceholderSelector = '.mass-edit-sticky-block-header-placeholder';
export const leftCurtainOffsetVarName = '--mass-edit-left-curtain-offset';
export const leftCurtainWidthVarName = '--mass-edit-left-curtain-width';

export const siblingListVisibleLeftCurtainOffset = -15;
export const siblingListVisibleLeftCurtainWidth = 75;
export const siblingListHiddenLeftCurtainOffset = -30;
export const siblingListHiddenLeftCurtainWidth = 90;


export function triggerFakeMassEditScroll () {
    $(stickyBlockSelector).trigger('fakeScroll');
}

// not used now
export function triggerHorizontalMassEditScroll () {
    $(massEditContainerSelector).each(function () {
        $(this).trigger('scroll');
    });
}

// not used now
export function triggerVerticalMassEditScroll () {
    window.dispatchEvent(new Event('scroll'));
}

// not used now
export function triggerMassEditScrollEvents () {
    triggerHorizontalMassEditScroll();
    triggerVerticalMassEditScroll();
}

export function setDocumentStyleVar (varName, value) {
    document.documentElement.style.setProperty(varName, value);
}

// not used now
export function adjustLeftCurtain (siblingListVisible) {
    if (siblingListVisible) {
        setDocumentStyleVar(leftCurtainOffsetVarName, `${siblingListVisibleLeftCurtainOffset}px`);
        setDocumentStyleVar(leftCurtainWidthVarName, `${siblingListVisibleLeftCurtainWidth}px`);
    } else {
        setDocumentStyleVar(leftCurtainOffsetVarName, `${siblingListHiddenLeftCurtainOffset}px`);
        setDocumentStyleVar(leftCurtainWidthVarName, `${siblingListHiddenLeftCurtainWidth}px`);
    }
}
